import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageNamespaceDelete
{
    constructor(targetElement)
    {
        const namespace = targetElement.dataset.namespace;
        if (!namespace) return;

        const url = "namespace/" + namespace + "/dependencies";

        const loadingEle = ele.byId("checkDelete");
        const errorEle = ele.byQuery("#problems .error");
        const containerEle = ele.byId("problems");
        const hintEle = ele.byId("hints");
        const deleteButton = ele.byId("deletebutton");

        api.get(url, (response) =>
        {
            if (loadingEle) ele.hide(loadingEle);
            const count = response.data.opsCount || "";
            if (count)
            {
                if (errorEle)
                {
                    const countEle = errorEle.querySelector(".count");
                    if (count)
                    {
                        if (countEle && response.data) countEle.innerText = count;
                    }
                    if (containerEle) ele.show(containerEle);
                }
            }
            else
            {
                if (deleteButton) ele.show(deleteButton);
                if (hintEle) ele.show(hintEle);
            }
        }, (e) =>
        {
            let msg = e.msg || JSON.stringify(e);
            if (errorEle)
            {
                errorEle.innerText = "Error: " + msg;
                ele.show(containerEle);
            }
            if (loadingEle) ele.hide(loadingEle);
        });
    }

    deleteNamespace(button, name, successUrl)
    {
        const errorEle = ele.byId("problems");
        if (errorEle) ele.hide(errorEle);
        web.buttons.startSavingAnimButton(button);
        api.delete(
            "namespace/" + name,
            {},
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button);
                if (successUrl)
                {
                    document.location.href = successUrl;
                }
                else
                {
                    document.location.reload();
                }
            },
            (e) =>
            {
                web.buttons.stopSavingAnimButton(button, true, true);
                let msg = e.msg || JSON.stringify(e);
                if (errorEle)
                {
                    const error = errorEle.querySelector(".error");
                    if (error)
                    {
                        error.innerText = "Failed to delete namespace: " + msg;
                        ele.show(errorEle);
                    }
                }
            });
    }
}
